import { render, staticRenderFns } from "./EvaluatePeriodicCreateDialog.vue?vue&type=template&id=66879c19&scoped=true"
import script from "./EvaluatePeriodicCreateDialog.vue?vue&type=script&lang=js"
export * from "./EvaluatePeriodicCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluatePeriodicCreateDialog.vue?vue&type=style&index=0&id=66879c19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66879c19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66879c19')) {
      api.createRecord('66879c19', component.options)
    } else {
      api.reload('66879c19', component.options)
    }
    module.hot.accept("./EvaluatePeriodicCreateDialog.vue?vue&type=template&id=66879c19&scoped=true", function () {
      api.rerender('66879c19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/EvaluatePeriodicCreateDialog.vue"
export default component.exports